import type { MerchantRelationship } from '~~/models/MerchantRelationship';

export const useGlobalMerchantRelationship = () => {
	return useState<MerchantRelationship | null>('global-merchant-relationship', () => null);
};
